import styles from 'styles/Home.module.css';

const Home = () => (
  <div className={styles.mainDiv}>
    <h2>Welcome to the Mathematics Application!</h2>
    <div>
      <p>
        Mathematics is the foundation of countless everyday calculations that we
        encounter in our lives. From splitting bills at a restaurant to
        calculating the area of a room, these mathematical operations are
        essential in our day-to-day activities. Our Simple Mathematics
        Application is here to make those calculations a breeze, providing you
        with a user-friendly platform to perform a wide range of normal
        calculations quickly and accurately.
      </p>
      <p>
        Whether you&apos;re a student, a professional, or someone who simply
        wants to have a handy tool for everyday math, our application is
        designed to meet your needs. With its sleek and intuitive interface,
        you&apos;ll find performing calculations effortless and enjoyable. Say
        goodbye to the hassle of manual calculations or digging through piles of
        papers—our application simplifies your mathematical tasks and saves you
        valuable time. Elevate your math experience with our Simple Mathematics
        Application! Plus, enjoy a touch of inspiration with our built-in random
        quotes feature, sourced from Ninjas API collection. Discover the power
        of numbers and wisdom in one place.
      </p>
    </div>
  </div>
);

export default Home;
